import React from 'react';

import MaterialDropdown from 'components/common/dropDown/materialDropdown';

import {
  NOTE_ROLE_FILTER,
  NOTE_STATUS_FILTER,
  DEFAULT_NOTE_ROLE_FILTER,
  DEFAULT_NOTE_STATUS_FILTER,
} from 'constants/appConstants';

import type { NoteSummaryFilters, NoteSummaryQuery } from '../interfaces';

interface Props {
  filters: NoteSummaryFilters;
  queryParams: NoteSummaryQuery;
  onStatusChange: (selectedStatus: string | null) => void;
  onRoleChange: (selectedRole: string | null) => void;
}

export default function NoteSummaryFilters({ filters, queryParams, onStatusChange, onRoleChange }: Props) {
  return (
    <div className="d-flex gap-10">
      <MaterialDropdown
        isSearchable={false}
        options={NOTE_STATUS_FILTER}
        isPlain
        isSmall
        autoResize
        value={NOTE_STATUS_FILTER.find((item) => filters.status === item.value) || DEFAULT_NOTE_STATUS_FILTER}
        onDropDownChange={(option) => {
          const selectedOption = Array.isArray(option) ? option[0] : option;

          onStatusChange((selectedOption?.value as string | null | undefined) ?? null);
        }}
        placeholder="Status"
      />
      <div className="d-flex">
        <MaterialDropdown
          isSearchable={false}
          options={NOTE_ROLE_FILTER}
          isPlain
          isBig
          autoResize
          value={NOTE_ROLE_FILTER.find((item) => queryParams.role === item.value) || DEFAULT_NOTE_ROLE_FILTER}
          onDropDownChange={(option) => {
            const selectedOption = Array.isArray(option) ? option[0] : option;

            onRoleChange((selectedOption?.value as string | null | undefined) ?? null);
          }}
          placeholder="Role"
        />
      </div>
    </div>
  );
}
